import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { TokenExists } from './token-exists';
import { ClientInformationResponse } from './client-information-response';
import { EmailConfirmationResponse } from './email-confirmation-response';
import { RescheduleInformation } from '../upcoming-dates';

@Injectable({
  providedIn: 'root'
})
export class RescheduleService {

  constructor(private http: HttpClient) { }

  doesToeknExist(token: string): Observable<TokenExists> {
    return this.http.get<TokenExists>(`/api/confirmToken?token=${token}`)
    .pipe(map( response => {
      return response
    }))
  }

  validateClientInformation(token: string, firstName: string, lastName: string, emailAddress: string, phoneNumber: string): Observable<ClientInformationResponse> {

    const body = new HttpParams()
        .set('token', token)
        .set('firstName', firstName)
        .set('test', 'test')
        .set('lastName', lastName)
        .set('emailAddress', emailAddress)
        .set('phoneNumber', phoneNumber.replace(/\D/g, ""));

    const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post<ClientInformationResponse>(`/api/validateClientInformation`, body, {headers: baseHeaders})
    .pipe(map( response => {
      return response
    }))
  }

  rescheduleAppointment(token: string, firstName: string, lastName: string, emailAddress: string, phoneNumber: string, appointmentTimeId: number): Observable<RescheduleInformation> {
    const data = `token=${token}` +
						`&firstName=${firstName}` +
						`&lastName=${lastName}` +
						`&emailAddress=${emailAddress}` +
						`&phoneNumber=${phoneNumber.replace(/\D/g, "")}` +
						`&appointmentTimeId=${appointmentTimeId}`
    const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post<RescheduleInformation>('/api/rescheduleAppointment', data, {headers: baseHeaders})
    .pipe(map( response => {
      return response
    }))
  }

  cancelAppointment(token: string, firstName: string, lastName: string, emailAddress: string, phoneNumber: string): Observable<EmailConfirmationResponse> {
    const data = `token=${token}` +
						`&firstName=${firstName}` +
						`&lastName=${lastName}` +
						`&emailAddress=${emailAddress}` +
						`&phoneNumber=${phoneNumber.replace(/\D/g, "")}`

    const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post<EmailConfirmationResponse>('/api/cancelAppointment', data, {headers: baseHeaders})
      .pipe(map( response => {
        return response
      }))

  }
		
  emailConfirmation(token: string, firstName: string, lastName: string, emailAddress: string, phoneNumber: string): Observable<EmailConfirmationResponse> {
    const data = `token=${token}` +
						`&firstName=${firstName}` +
						`&lastName=${lastName}` +
						`&emailAddress=${emailAddress}` +
						`&phoneNumber=${phoneNumber.replace(/\D/g, "")}`

    const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post<EmailConfirmationResponse>('/api/emailConfirmation', data, {headers: baseHeaders})
      .pipe(map( response => {
        return response
      }))
  }
}
